import Vue from 'vue';

function load(path) {
  return () => import(`@/components/${path}.vue`);
}

Vue.component('alert', load('alert'));
